import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Sidebar = () => {
  const [responses, setResponses] = useState([
    { text: "Israel stands strong and united.", id: 1 },
    { text: "Defending our people is our priority.", id: 2 },
    { text: "Hasbara.ai actively countering misinformation.", id: 3 }
  ]);

  useEffect(() => {
    // Simulated API call for latest responses
    axios.get(`${process.env.REACT_APP_API_SERVER_URL}/api/latest-responses`)
      .then(response => setResponses(response.data || []))
      .catch(error => console.error("Error fetching responses:", error));
  }, []);

  return (
    <aside style={styles.sidebar}>
      <h3 style={styles.title}>Latest Responses</h3>
      <div style={styles.responseContainer}>
        {responses.length > 0 ? (
          responses.map((response) => (
            <div key={response.id} style={styles.responseBox}>
              <p style={styles.handle}>@Hasbara.ai</p>
              <p style={styles.reply}>{response.text}</p>
            </div>
          ))
        ) : (
          <p style={styles.noResponses}>No responses yet.</p>
        )}
      </div>
    </aside>
  );
};

// Styles
const styles = {
  sidebar: {
    width: '300px',
    backgroundColor: '#f8f9fa',
    padding: '15px',
    borderLeft: '2px solid #ddd',
    height: '122vh',
    right: 0,
    top: '60px',
    overflowY: 'auto',
    boxShadow: '-2px 0 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
  title: {
    fontSize: '20px',
    marginBottom: '10px',
    textAlign: 'center',
    color: '#595959',
  },
  responseContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  responseBox: {
    backgroundColor: '#fff',
    padding: '10px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    borderLeft: '4px solid #007bff',
  },
  handle: {
    fontWeight: 'bold',
    color: '#007bff',
    marginBottom: '5px',
  },
  reply: {
    fontSize: '14px',
    color: '#333',
  },
  noResponses: {
    textAlign: 'center',
    color: '#777',
  },
};

export default Sidebar;
